const debounceLogosSubtextStyling = function(func) {
    var timer;
    return function(event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
    };
}

const logosSubtextStyling = function(event) {
    console.log('logosSubtextStyling')
    let logosSections = document.querySelectorAll('.logos_with_or_without_text')
    logosSections.forEach((logosSection) => {
        let sectionId = logosSection.closest('.shopify-section') && logosSection.closest('.shopify-section').getAttribute('id');
        const settings = {
            sectionSelector: `#${sectionId}`,
            textWrapperSelector: `.c-lwt-mobile-text-wrapper`,
            textSelector: `.c-lwt-text`,
            subTextSelector: `.c-lwt-subtext`
        };
    
        const section = document.querySelector(`${settings.sectionSelector}`);
        if (section) {
            const textArray = section.querySelectorAll(`${settings.textSelector}`);
            const subTextArray = section.querySelectorAll(`${settings.subTextSelector}`);
            const textWrapperArray = section.querySelectorAll(`${settings.textWrapperSelector}`);
    
            if (textArray.length > 0 && subTextArray.length > 0) {
                let textHeightArray = [];
                let subTextHeightArray = []
                textArray.forEach((text) => {
                    textHeightArray.push(text.offsetHeight)
                });
                let maxHeightText = textHeightArray.sort().reverse()[0];	
    
                subTextArray.forEach((subText) => {
                    subTextHeightArray.push(subText.offsetHeight);
                    if (window.innerWidth > 600) {
                        subText.style.top = `${maxHeightText}px`;
                    } else {
                        subText.style.top = 0;
                    }
                });
    
                let maxHeightSubText = subTextHeightArray.sort().reverse()[0];
    
                textWrapperArray.forEach((textWrapper) => {
                    if (window.innerWidth > 600) {
                        textWrapper.style.paddingBottom = `${maxHeightSubText}px`;
                    } else {
                        textWrapper.style.paddingBottom = 0;
                    }
                });
            }
        }
    })
}

// window.addEventListener('load', function(){
//     logosSubtextStyling("onLoad");
//     window.addEventListener("resize", debounceLogosSubtextStyling(() => logosSubtextStyling("onResize")));
// });

